import React from 'react';
import './FeatureMark.css';

type FeatureKind =
  | 'ofac'
  | 'website'
  | 'cloud'
  | 'government'
  | 'campus'
  | 'ai'
  | 'legal'
  | 'dashboard'
  | 'research'
  | 'monitor'
  | 'alert'
  | 'audit'
  | 'pricing'
  | 'people'
  | 'report'
  | 'calendar'
  | 'grid';

export function featureKind(key: string): FeatureKind {
  const value = key.toLowerCase();
  if (value.includes('ofac')) return 'ofac';
  if (value.includes('website')) return 'website';
  if (value.includes('cloud')) return 'cloud';
  if (value.includes('dod') || value.includes('government')) return 'government';
  if (value.includes('education') || value.includes('campus')) return 'campus';
  if (value.includes('ai-') || value.includes('ai compliance') || value.endsWith('ai')) return 'ai';
  if (value.includes('business') || value.includes('legal') || value.includes('formation') || value.includes('will') || value.includes('trust')) return 'legal';
  if (value.includes('dashboard')) return 'dashboard';
  if (value.includes('research') || value.includes('vantage')) return 'research';
  if (value.includes('alert')) return 'alert';
  if (value.includes('audit') || value.includes('case')) return 'audit';
  if (value.includes('monitor') || value.includes('screening')) return 'monitor';
  if (value.includes('pricing') || value.includes('usage')) return 'pricing';
  if (value.includes('consultant')) return 'people';
  if (value.includes('report') || value.includes('executive')) return 'report';
  if (value.includes('scheduled')) return 'calendar';
  return 'grid';
}

const stroke = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

function Mark({ kind }: { kind: FeatureKind }) {
  if (kind === 'ofac') {
    return <svg {...stroke}><path d="M12 3 5 6v5c0 4.2 2.8 7.2 7 9 4.2-1.8 7-4.8 7-9V6l-7-3Z" /><path d="m9 12 2 2 4-4" /></svg>;
  }
  if (kind === 'website') {
    return <svg {...stroke}><circle cx="12" cy="12" r="8" /><path d="M4 12h16M12 4c2.2 2.4 3.4 5 3.4 8s-1.2 5.6-3.4 8c-2.2-2.4-3.4-5-3.4-8s1.2-5.6 3.4-8Z" /></svg>;
  }
  if (kind === 'cloud') {
    return <svg {...stroke}><path d="M7 18h10a4 4 0 0 0 .4-8 5 5 0 0 0-9.6-1.4A3.5 3.5 0 0 0 7 18Z" /></svg>;
  }
  if (kind === 'government') {
    return <svg {...stroke}><path d="M12 3 4 7v2h16V7L12 3Z" /><path d="M6 9v8M10 9v8M14 9v8M18 9v8M4 17h16v3H4v-3Z" /></svg>;
  }
  if (kind === 'campus') {
    return <svg {...stroke}><path d="M3 10 12 4l9 6" /><path d="M5 10v8h14v-8" /><path d="M12 14v4" /></svg>;
  }
  if (kind === 'ai') {
    return <svg {...stroke}><path d="M12 3v3M12 18v3M3 12h3M18 12h3" /><circle cx="12" cy="12" r="4" /></svg>;
  }
  if (kind === 'legal') {
    return <svg {...stroke}><path d="M4 20h16" /><path d="M6 20V10l6-6 6 6v10" /><path d="M10 20v-5h4v5" /></svg>;
  }
  if (kind === 'dashboard') {
    return <svg {...stroke}><rect x="4" y="4" width="7" height="7" rx="1.2" /><rect x="13" y="4" width="7" height="4" rx="1.2" /><rect x="13" y="10" width="7" height="10" rx="1.2" /><rect x="4" y="13" width="7" height="7" rx="1.2" /></svg>;
  }
  if (kind === 'research') {
    return <svg {...stroke}><circle cx="11" cy="11" r="6" /><path d="m20 20-3.5-3.5" /></svg>;
  }
  if (kind === 'monitor') {
    return <svg {...stroke}><path d="M4 13c2-4 3.5-6 5-6s2.2 3 3.5 6 2 6 3.5 6 3-2 4-6" /></svg>;
  }
  if (kind === 'alert') {
    return <svg {...stroke}><path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2H4.5L6 16Z" /><path d="M10 19a2 2 0 0 0 4 0" /></svg>;
  }
  if (kind === 'audit') {
    return <svg {...stroke}><path d="M8 4h8l3 3v13H8V4Z" /><path d="M16 4v3h3M10 12h6M10 16h4" /></svg>;
  }
  if (kind === 'pricing') {
    return <svg {...stroke}><path d="M4 12 12 4h7v7l-8 8L4 12Z" /><circle cx="16" cy="8" r="1" /></svg>;
  }
  if (kind === 'people') {
    return <svg {...stroke}><circle cx="9" cy="8" r="3" /><path d="M3.5 19c.8-2.6 2.8-4 5.5-4s4.7 1.4 5.5 4" /><circle cx="17" cy="9" r="2" /></svg>;
  }
  if (kind === 'report') {
    return <svg {...stroke}><path d="M6 3h9l4 4v14H6V3Z" /><path d="M15 3v4h4M8 13h8M8 17h5" /></svg>;
  }
  if (kind === 'calendar') {
    return <svg {...stroke}><rect x="4" y="5" width="16" height="15" rx="2" /><path d="M8 3v4M16 3v4M4 10h16" /></svg>;
  }
  return <svg {...stroke}><rect x="4" y="4" width="6.5" height="6.5" rx="1.2" /><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.2" /><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.2" /><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.2" /></svg>;
}

export const FeatureMark: React.FC<{ featureKey: string }> = ({ featureKey }) => {
  const kind = featureKind(featureKey);
  return (
    <span className={`feature-mark feature-mark--${kind}`} aria-hidden="true">
      <Mark kind={kind} />
    </span>
  );
};
